import { createBrowserRouter } from "react-router-dom";
import { LoginPage } from "../../components/admin-panel/login/login-page";
import { Dashboard } from "../../components/admin-panel/dashboard/dashboard";
import { SignUpPage } from "../../components/admin-panel/signup/signup-page";
import { RouteName } from "./routes.helper";
import NotFound from "../../components/not-found/not-found.page";
import LandingPage from "../../components/landing-page/landing-page";
import ProtectedRoute from "../../components/protected-route/protected-route";
import BookingList from "../../components/admin-panel/bookings/booking-list";
import ShowList from "../../components/admin-panel/shows/show-list";
import SettingsList from "../../components/admin-panel/settings/settings-list";
import TheaterList from "../../components/admin-panel/theaters/theater-list";
import BookingSuccess from "../../components/booking-page/success/booking-success";
import BookingFailure from "../../components/booking-page/failure/booking-failure";
import BookingError from "../../components/booking-page/error/booking-error";
import UsersList from "../../components/admin-panel/users/users-list";
import BookingCheckIn from "../../components/booking-page/check-in/booking-check-in";
import ContentList from "../../components/admin-panel/content/content-list";
import ImportBookingsPage from "../../components/admin-panel/import-bookings/import-bookings.page";

export const router = createBrowserRouter([
  {
    path: RouteName.LANDING,
    element: <LandingPage />,
  },
  {
    path: RouteName.BOOKING_SUCCESS,
    element: <BookingSuccess />,
  },
  {
    path: RouteName.BOOKING_FAILURE,
    element: <BookingFailure />,
  },
  {
    path: RouteName.BOOKING_ERROR,
    element: <BookingError />,
  },
  {
    path: RouteName.BOOKING_CHECK_IN,
    element: <BookingCheckIn />,
  },
  {
    path: RouteName.LOGIN,
    element: <LoginPage />,
  },
  ...(process.env.NODE_ENV !== 'production' ? [{
    path: RouteName.SIGNUP,
    element: <SignUpPage />,
  }] : []),
  {
    element: <ProtectedRoute />,
    path: RouteName.ADMIN,
    children: [
      {
        path: RouteName.DASHBOARD,
        element: <Dashboard />,
      },
      {
        path: RouteName.BOOKINGS,
        element: <BookingList />,
      },
      {
        path: RouteName.THEATERS,
        element: <TheaterList />,
      },
      {
        path: RouteName.CALENDAR,
        element: <ShowList />,
      },
      {
        path: RouteName.USERS,
        element: <UsersList />,
      },
      {
        path: RouteName.SETTINGS,
        element: <SettingsList />,
      },
      {
        path: RouteName.CONTENT,
        element: <ContentList />,
      },
      {
        path: RouteName.IMPORT_BOOKINGS,
        element: <ImportBookingsPage />,
      },
    ],
  },
  {
    path: RouteName.WILDCARD,
    element: <NotFound />,
  },
]);
